export const DISABLE_INHERIT_LIST = [
  'Strip',
  'FlexStrip',
  'Form',
  'ContinualForm',
  'Section',
  'Stack',
  'Scroll',
  'Tab',
  'Accordion',
  'Stepper',
  'MultiStepper',
  'CarouselContainer',
  'TwoSideSection',
]
